import {
  findFacilityById,
  findSchedulesByPartnerId,
} from '@/app/(main)/(pages)/_services/search-api/search-api.service';
import {
  SearchApiPartnerProcedureGroup,
  SearchApiServiceChannel,
} from '@/app/(main)/(pages)/_types/search-api-response.type';
import { getLogger } from '@/logger/logger';

export const MAX_PROCEDURE_IDS = 50;

export interface FindFacilityProcedureGroupsParams {
  facilityId: string;
  procedureIds: string[];
}

export interface FindFacilityProcedureGroupsResult {
  partnerId: string | null;
  groups: SearchApiPartnerProcedureGroup[];
  requestedProcedureIds: string[];
}

export async function findFacilityProcedureGroups({
  facilityId,
  procedureIds,
}: FindFacilityProcedureGroupsParams): Promise<FindFacilityProcedureGroupsResult> {
  const logger = getLogger('findFacilityProcedureGroups');
  const requestedProcedureIds = procedureIds.slice(0, MAX_PROCEDURE_IDS);

  if (procedureIds.length > MAX_PROCEDURE_IDS) {
    logger.warn('Truncating procedure ids to the route limit', {
      facilityId,
      requested: procedureIds.length,
      limit: MAX_PROCEDURE_IDS,
    });
  }

  const facility = await findFacilityById(facilityId);

  if (!facility?.partnerId) {
    logger.warn('Facility has no partner id', { facilityId });

    return { partnerId: null, groups: [], requestedProcedureIds };
  }

  const { groups } = await findSchedulesByPartnerId(facility.partnerId, {
    partnerFacilityId: facilityId,
    procedureIds: requestedProcedureIds,
    serviceChannel: SearchApiServiceChannel.IN_PERSON,
    limit: MAX_PROCEDURE_IDS,
  });

  return { partnerId: facility.partnerId, groups, requestedProcedureIds };
}
